/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import {
  AppServiceMachineType,
  AppServiceRequestProcessor,
} from "../../state-machine";
import config from "../config/analyticsWidget.config.json";
import { VApplication } from "../../../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_DASHBOARD_ANALYTICS_QUERY } from "../graphql/getDashBoardAnalytics.query";
import { AnalyticsResultFormatterMessage } from "../messages/analytics-result-formatter.message";
import { ANALYTICS_RESULT_FORMATTER_CONFIG } from "../machines/analytics-result-formatter/config";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IAnalyticsWidgetMethods extends IPluginMethodMap {
  getAnalyticsWidgetProps(args: any): Promise<any>;
}

export class AnalyticeWidgetService
  extends AppServiceRequestProcessor
  implements IAgentPlugin
{
  readonly methods: IAnalyticsWidgetMethods;

  constructor() {
    super();
    this.methods = {
      getAnalyticsWidgetProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_DASHBOARD_ANALYTICS_QUERY,
          fetchPolicy: "network-only",
        });
        if (res?.data?.getDashBoardAnalytics) {
          const message = new AnalyticsResultFormatterMessage({
            raw: res?.data?.getDashBoardAnalytics,
            template: { ...(config || {}) },
          });
          this.startSyncProcessing({
            machineConfig: {
              ...ANALYTICS_RESULT_FORMATTER_CONFIG,
              data: {
                message: message,
              },
            },
            machineType: AppServiceMachineType.DASHBOARD_ANALYTICS_FORMATTER,
          });
          return this._getResult(res?.data?.getDashBoardAnalytics, message?.template);
        }
      }
    } catch (err: any) {
      console.log(`error in getDashboardQuery`, err);
      throw Error(err?.message);
    }
  }

  private _getResult(data:any, template:any){
    const _temp = template?.layout[0]?.colProps;
    const _template = template;
    if(!Array.isArray(data?.discountStats) || data?.discountStats === null || (Array.isArray(data?.discountStats) && data?.discountStats?.length === 0)){
      _temp?.filter(ele=>{
        return ele.key !== "totalGrantSum" || ele.key !== "consumedGrant" || ele.key !== "consumedPolicies";
      })
    }
    _template.layout[0].colProps = _temp;
    return _template;
  }
}
